<template>
  <div class="mapHistoryDateHint">
    <svgicon icon="history" width="32" height="32"></svgicon>
    {{date|defaultDay}},
    {{date|defaultDate}}
      {{date|defaultTime}}
  </div>
</template>

<script>

export default {
  name: 'MapHistoryDateHint',
  props: ['date']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .mapHistoryDateHint {
    position: absolute;
    bottom: 20px;
    left: 20px;
    z-index: 9999;
    padding: 0px 20px 0px 10px;
    line-height: 48px;
    font-size: 17px;
    font-weight: bold;
    color: #fff;
    background: rgba($color-text,0.9);
    box-shadow: 0 2px 5px 0 rgba($color-text,0.3);
  }

</style>



// WEBPACK FOOTER //
// src/components/MapHistoryDateHint.vue